import React, { useState } from "react";

// Form component for creating or editing style color entries
const Form = ({ handleSubmit, formData, onDiscard }) => {
  // State to hold form data and error states
  const [form, setForm] = useState(formData);
  const [errorColorHexCode, setErrorColorHexCode] = useState(false); // Error state for color hex code
  const [errorTransparency, setErrorTransparency] = useState(false); // Error state for transparency
  const [errorStroke, setErrorStroke] = useState(false); // Error state for stroke

  // Handle input changes to update form state
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value, // Update the relevant field in the form state
    });
  };

  // Handle click event for submitting the form
  const handleClick = () => {
    // Reset error states
    setErrorColorHexCode(false);
    setErrorTransparency(false);
    setErrorStroke(false);

    // Validate Color Hex Code
    if (!form.color_hex_code) setErrorColorHexCode(true);

    // Validate Transparency
    if (!form.transparency) setErrorTransparency(true);

    // Validate Stroke
    if (!form.stroke) setErrorStroke(true);

    // If all fields are valid, submit the form
    if (form.color_hex_code && form.transparency && form.stroke) {
      handleSubmit(form); // Send the new data to the parent component
    }
  };

  return (
    <>
      {/* Color Hex Code Input */}
      <div className="row mt-4">
        <label htmlFor="color_hex_code" className="form-labels">Color Hex Code:</label>

        {/* Color Picker Input */}
        <div className="col-2 col-sm-2">
          <input
            type="color"
            name="color_hex_code"
            id="color_hex_code"
            value={form.color_hex_code} // Set the input value to the form state
            placeholder="Default input"
            onChange={handleChange} // Handle input change
            className="form-control mt-2 inputs"
          />
        </div>

        {/* Error message for Color Hex Code */}
        {errorColorHexCode ? (
          <span id="errorColorHexCode" className="form-text text-danger">
            Color Hex Code is required!
          </span>
        ) : (
          <span></span>
        )}
      </div>

      {/* Transparency Input */}
      <div className="mt-4">
        <label htmlFor="transparency" className="form-labels">Transparency:</label>

        <input
          type="text"
          name="transparency"
          id="transparency"
          placeholder="Default input"
          onChange={handleChange} // Handle input change
          value={form.transparency} // Set the input value to the form state
          className="form-control mt-2 inputs"
        />

        {/* Error message for Transparency */}
        {errorTransparency ? (
          <span id="errorTransparency" className="form-text text-danger">
            Transparency is required!
          </span>
        ) : (
          <span></span>
        )}
      </div>

      {/* Stroke Input */}
      <div className="mt-4">
        <label htmlFor="stroke" className="form-labels">Stroke:</label>

        <input
          type="text"
          name="stroke"
          id="stroke"
          placeholder="Default input"
          onChange={handleChange} // Handle input change
          value={form.stroke} // Set the input value to the form state
          className="form-control mt-2 inputs"
        />

        {/* Error message for Stroke */}
        {errorStroke ? (
          <span id="errorStroke" className="form-text text-danger">
            Stroke is required!
          </span>
        ) : (
          <span></span>
        )}
      </div>

      {/* Action Buttons */}
      <div className="pt-5">
        {/* Discard Button */}
        <div className="btn btn-secondary form-btn me-4" onClick={onDiscard}>
          Discard
        </div>
        {/* Save Changes Button */}
        <input
          type="submit"
          value="Save Changes"
          className="btn bg-orange form-btn"
          onClick={handleClick} // Handle click to save changes
        />
      </div>
    </>
  );
};

export default Form;
